import { ProductSection } from 'components'
import React from 'react'

const ProductsPage = () => {
  return (
    <div>
      <ProductSection/>
    </div>
  )
}

export {ProductsPage}
